import moment from "moment";

import { useBirthingInformation } from "@/encounters/hooks/useBirthingInformation";

/**
 * Formats the newborn's birth date, birth time, and days since birth for the Newborn Postpartum
 * encounter.
 *
 * @returns The birth date (`MM/dd/yyyy`), birth time (`hh:mm:ss`), and full 24-hour days since
 *   birth.
 */
export const useNewbornBirthingInformation = () =>
  useBirthingInformation({
    birthTimeFormat: "hh:mm:ss",
    countDaysSinceBirth: countFullDaysSinceBirth,
  });

/**
 * Counts the full 24-hour periods elapsed since birth.
 *
 * @param birthDateTime - The stored birth date-time.
 * @returns The number of whole days elapsed since birth.
 */
const countFullDaysSinceBirth = (birthDateTime: string) =>
  moment().diff(moment(birthDateTime), "days");
